module.exports = __webpack_public_path__ + "static/media/vaseExplore.6b0159a0.png";